<template>
    <div>
         <!--面包屑导航区域-->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>设备管理</el-breadcrumb-item>
            <el-breadcrumb-item>设置淋浴</el-breadcrumb-item>
        </el-breadcrumb>
        <!--面包屑导航区域-->
        <!--卡片视图区-->
        <br>
        <el-card>
            <!--搜索与添加区域-->
            <el-row :gutter="20">
                <el-col :span="20">
                    <el-input placeholder="请输入门店名称/门店序号搜索" clearable v-model="queryInfo.query" @clear="handleQuery()" @keyup.enter.native="handleQuery()" style="width: 500px;">
                        <el-button slot="append" icon="el-icon-search" @click="handleQuery()"></el-button>
                    </el-input>
                </el-col>
                <el-col :span="4">
                    <el-button type="primary" icon="el-icon-plus" @click="AddStoreBath()" v-permission="'btn:bath:add'">设置门店淋浴</el-button>
                </el-col>
            </el-row>
            <!--搜索与添加区域-->
            <br>
            <!--用户列表区域-->
            <el-table v-loading="loading" :data="list"  :key="list.index" style="width: 100%" stripe size="middle" height="780">
                <el-table-column label="序号" type="index"  width="100"></el-table-column>
              <el-table-column label="门店序号" prop="xh" width="100"></el-table-column>
                <el-table-column label="门店名称" prop="storename" width="300"></el-table-column>
                <el-table-column label="扫码次数" prop="count" width="100"></el-table-column>
                <el-table-column label="淋浴topic" prop="topics" show-overflow-tooltip  width="700"></el-table-column>
                <el-table-column label="淋浴二维码" width="300">
                  <template slot-scope="scope">
                    <div v-if="scope.row.qrcodes">
                      <img :src="prefix + code.qrcode" width="40px" height="40px" style="margin-right: 5px" v-for="code in scope.row.qrcodes" :key="code.name" @click="handleLookPic(code.qrcode)"/>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="设置时间" prop="adddate"   width="200"></el-table-column>
                <el-table-column label="操作" width="350">
                    <!--作用域插槽-->
                    <template slot-scope="scope">
                        <div class="button-group">
                            <el-tooltip content="编辑" placement="top" :enterable="false">
                                <el-button type="success" icon="el-icon-edit" size="mini" circle @click="EditInfo(scope.row.id)" v-permission="'btn:bath:edit'"></el-button>
                            </el-tooltip>
                            <el-tooltip content="删除" placement="top" :enterable="false">
                                <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="DelInfo(scope.row.id)" v-permission="'btn:bath:delete'"></el-button>
                            </el-tooltip>
                            <el-button type="primary" icon="el-icon-plus" size="mini" @click="createQrcode(scope.row)" v-permission="'btn:bath:qrcode:create'">生成二维码</el-button>
                            <el-button type="info" icon="el-icon-download" size="mini" @click="downloadQrcode(scope.row)" v-if="scope.row.qrcodes" v-permission="'btn:bath:qrcode:download'">下载二维码</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!--用户列表区域-->
            <!--分页区域-->
            <br>
            <div align="center">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="queryInfo.pagenum" :page-sizes="[50,500,1000]"  :page-size="queryInfo.pagesize"
                layout="total, sizes, prev, pager, next" :total="total">
                </el-pagination>
            </div>
            <!--分页区域-->
            <!--添加对话框-->
            <el-dialog title="添加门店淋浴" :visible.sync="addDialogVisible" width="60%" top="150px" @close="addDialogClosed">
                <div style="height: 500px;overflow-y: auto">
                    <el-form :model="addForm" :rules="addFormRules" ref="addFormRef"  label-width="100px">
                        <el-form-item label="选择门店" prop="storeid">
                            <el-select v-model="addForm.storeid"  @change="handleStoreChange" filterable placeholder="请选择门店"  style="width: 280px;margin-left: 10px;" clearable>
                                <el-option v-for="item in storelist" :key="item.id" :label="item.storename" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="扫码次数" prop="count" v-if="storeInfo.newFlag !== 'Y'">
                            <el-input-number v-model="addForm.count" :min="1" :max="10" style="margin-left: 10px;"></el-input-number>
                        </el-form-item>
                        <el-form-item label="设备Topic" prop="deviceTopic" v-if="storeInfo.newFlag !== 'Y'">
                          <el-input v-model="addForm.deviceTopic" placeholder="设备Topic" @blur="handleBlur"></el-input>
                        </el-form-item>
                        <el-form-item
                            v-for="(owner, index) in addForm.owners"
                            :label="'淋浴' + (index + 1) +'号'"
                            :key="owner.key"
                            :prop="'owners.' + index + '.topic'"
                            v-show="storeInfo.newFlag !== 'Y'">
                            <el-input v-model="owner.topic" :disabled="true" placeholder="端口" style="width: 300px; margin:0 10px ;"></el-input>
                            <el-button @click.prevent="removeOwner(owner)">删除</el-button>
                        </el-form-item>
                      <el-form-item label="淋浴设备" v-if="storeInfo.newFlag === 'Y'">
                        <el-table :data="controls" height="250" border style="width: 100%">
                          <el-table-column type="index" label="序号" width="100" align="center"/>
                          <el-table-column prop="lyId" label="淋浴控制器" align="center">
                            <template slot-scope="scope">
                              <el-select v-model="scope.row.lyId" @change="handleManagerChange(scope.$index)" placeholder="请选择控制器"  style="width: 280px;margin-left: 10px;" clearable>
                                <el-option v-for="item in lyDevices" :key="item.id" :label="item.lyIp" :value="item.lyKey"></el-option>
                              </el-select>
                            </template>
                          </el-table-column>
                          <el-table-column prop="port" label="端口" align="center">
                            <template slot-scope="scope">
                              <el-select v-model="scope.row.port" clearable placeholder="请选择">
                                <el-option
                                    v-for="item in filterRelays(scope.row.lyId, scope.row.port)"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                              </el-select>
                            </template>
                          </el-table-column>
                          <el-table-column label="操作" align="center" width="100">
                            <template slot-scope="scope">
                              <el-button type="primary" @click="handleDeleteRelay(scope.$index)">删除</el-button>
                            </template>
                          </el-table-column>
                        </el-table>
                      </el-form-item>
                    </el-form>
                </div>
                <span slot="footer" class="dialog-footer" style="margin:0">
                    <el-button @click="addOwner" v-if="addForm.storeid">新增淋浴</el-button>
                    <el-button @click="AddInfo" style="background:#19aa8d;color:#fff" v-loading="btnLoading">确 定</el-button>
                </span>
            </el-dialog>
            <!--添加对话框-->
            <!-- 编辑对话框 -->
            <el-dialog title="编辑门店淋浴" :visible.sync="editDialogVisible" width="60%" top="50px" @close="editDialogClosed">
                <div style="height: 500px;overflow-y: auto">
                    <el-form :model="editForm" :rules="editFormRules" ref="editFormRef"  label-width="100px">
                        <el-form-item label="选择门店" prop="storeid">
                            <el-select v-model="editForm.storeid"  placeholder="请选择门店"  style="width: 280px;" clearable disabled>
                                <el-option v-for="item in storelist" :key="item.id" :label="item.storename" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="扫码次数" prop="count" v-if="storeInfo.newFlag !== 'Y'">
                            <el-input-number v-model="editForm.count" :min="1" :max="10" style="margin-left: 10px;"></el-input-number>
                        </el-form-item>
                      <el-form-item label="设备Topic" prop="deviceTopic" v-if="storeInfo.newFlag !== 'Y'">
                        <el-input v-model="editForm.deviceTopic" placeholder="设备Topic" @blur="handleBlurEdit"></el-input>
                      </el-form-item>
                        <el-form-item
                            v-for="(owner, index) in editForm.topics"
                            :label="'淋浴' + (index + 1) + '号'"
                            :key="owner.key"
                            v-show="storeInfo.newFlag !== 'Y'"
                            :prop="'topics.' + index + '.topic'">
                            <el-input v-model="owner.topic" :disabled="true" placeholder="端口" style="width: 300px; margin:0 10px ;"></el-input>
                            <el-button @click.prevent="removeOwner1(owner)">删除</el-button>
                        </el-form-item>
                      <el-form-item label="淋浴设备" v-if="storeInfo.newFlag === 'Y'">
                        <el-table :data="controls" height="250" border style="width: 100%">
                          <el-table-column type="index" label="序号" width="100" align="center"/>
                          <el-table-column prop="name" label="淋浴控制器" align="center">
                            <template slot-scope="scope">
                              <el-select v-model="scope.row.lyId" @change="handleManagerChange(scope.$index)" placeholder="请选择控制器"  style="width: 280px;margin-left: 10px;" clearable>
                                <el-option v-for="item in lyDevices" :key="item.id" :label="item.lyIp" :value="item.lyKey"></el-option>
                              </el-select>
                            </template>
                          </el-table-column>
                          <el-table-column prop="relayNum" label="端口" align="center">
                            <template slot-scope="scope">
                              <el-select v-model="scope.row.port" clearable placeholder="请选择">
                                <el-option
                                    v-for="item in filterRelays(scope.row.lyId, scope.row.port)"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                              </el-select>
                            </template>
                          </el-table-column>
                          <el-table-column label="操作" align="center" width="100">
                            <template slot-scope="scope">
                              <el-button type="primary" @click="handleDeleteRelay(scope.$index)">删除</el-button>
                            </template>
                          </el-table-column>
                        </el-table>
                      </el-form-item>
                    </el-form>
                </div>
                <span slot="footer" class="dialog-footer" style="margin:0">
                    <el-button @click="addOwner1" v-if="editForm.storeid">新增淋浴</el-button>
                    <el-button @click="EditInfoSave" style="background:#19aa8d;color:#fff" v-loading="btnLoading">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 编辑对话框 -->
        </el-card>
    </div>
</template>
<script>
import JSZip from "jszip";
import FileSaver from "file-saver";

export default {
    data() {
        return{
          btnLoading: false,
          prefix: '',
            queryInfo: {
                query: '',
                pagenum: 1,
                pagesize: 50
            },
            total:0,
            list: [],
            loading:false,
            addDialogVisible:false,
            editDialogVisible:false,
            storelist:[],
            //添加表单数据
            addForm:{
              storeid:'',
              deviceTopic:'',
              count:1,
              owners: [
                  {
                      topic: '',
                      key: Date.now()
                  }
              ]
            },
            editForm:{},
            addFormRules:{
                storeid:[
                    { required: true, message: '请选择门店', trigger: 'blur' }
                ],
                deviceTopic:[
                    { required: true, message: '请填写设备Topic', trigger: 'blur' }
                ]
            },
            editFormRules:{
                storeid:[
                    { required: true, message: '请选择门店', trigger: 'blur' }
                ],
              deviceTopic:[
                { required: true, message: '请填写设备Topic', trigger: 'blur' }
              ]
            },
          storeInfo: {},
          storeMap: new Map(),
          lyDevices: [],
          relayNums: [
            {
              value: "1",
              label: '端口一'
            },
            {
              value: "2",
              label: '端口二'
            },
            {
              value: "3",
              label: '端口三'
            },
            {
              value: "4",
              label: '端口四'
            }
          ],
          controls: []
        }
        
    },
    created(){
      this.prefix = this.$http.defaults.baseURL
      this.getList()
    },
    methods:{
      filterRelays(lyId,port){
        let arr = this.controls.filter(item => item.lyId === lyId).map(item=> item.port)
        return this.relayNums.filter(relay => arr.indexOf(relay.value) === -1 || relay.value === port)
      },
      handleQuery() {
        this.queryInfo.pagenum = 1
        this.getList()
      },
        async getList() {
            this.loading = true
           const { data: res} = await this.$http.get('bathlist/',{ params: this.queryInfo })
           if(res.status == 1){
                this.total = res.data.totalCount;
                this.list = res.data.list.map(v => {
                //在返回的数据里增加一条数据
                // console.log(v.fields)
                return v.fields
                })
                this.loading = false
            }
            for (let index = 0; index < res.data.list.length; index++) {
                this.list[index].id= res.data.list[index].pk;
            }

        },
        handleSizeChange(newSize){
           this.queryInfo.pagesize = newSize
           this.getList()
       },
       handleCurrentChange(newPage){
           this.queryInfo.pagenum = newPage
           this.getList()
       },
       AddStoreBath(){
         this.getStoreList()
         this.addForm = {
           storeid:'',
           deviceTopic:'',
           count:1,
           owners: [
             {
               topic: '',
               key: Date.now()
             }
           ],
           admin_token: window.sessionStorage.getItem('admin_token')
         }
         this.storeInfo = {}
         this.addFormRules.deviceTopic = [
           { required: true, message: '请填写设备Topic', trigger: 'blur' }
         ]
         this.controls = []
         this.lyDevices = []
         this.addDialogVisible =  true
       },
       addDialogClosed(){
            this.$refs.addFormRef.resetFields()
       },
       editDialogClosed(){
            this.$refs.editFormRef.resetFields()
       },
       async getStoreList(){
            const { data: res } = await this.$http.get('store/')
            this.storelist = res.data
         this.storelist.forEach(item => {
           this.storeMap.set(item.id, item)
         })
       },
       addOwner() {
          if (this.storeInfo.newFlag === 'Y') {
            this.controls.push({
              lyId: null,
              port: null
            })
          } else {
            this.addForm.owners.push({
              topic: this.addForm.deviceTopic + "_" + (this.addForm.owners.length + 1),
              key: Date.now()
            })
          }
       },
       removeOwner(item) {
         if (this.addForm.owners.length > 1) {
           let owners = []
           let sl = 0
           this.addForm.owners.forEach((owner) => {
             if (owner.key !== item.key) {
               sl += 1
               owners.push({
                 key: owner.key,
                 topic: this.addForm.deviceTopic + "_" + sl,
               })
             }
           })
           this.addForm.owners = owners;
         }
       },
       addOwner1() {
         if (this.storeInfo.newFlag === 'Y') {
           this.controls.push({
             lyId: null,
             port: null
           })
         } else {
           this.editForm.topics.push({
             topic: this.editForm.deviceTopic + "_" + (this.editForm.topics.length + 1),
             key: Date.now()
           })
         }
        },
        removeOwner1(item) {
          if (this.editForm.topics.length > 1) {
            let owners = []
            let sl = 0
            this.editForm.topics.forEach((owner) => {
              console.log(owner)
              if (owner.key !== item.key) {
                sl += 1
                owners.push({
                  key: owner.key,
                  topic: this.editForm.deviceTopic + "_" + sl,
                })
              }
            })
            this.editForm.topics = owners;
          }
        },
       AddInfo(){
            this.$refs.addFormRef.validate( async valid=>{
                if (!valid) return
              this.btnLoading = true
              let params = {...this.addForm}
              if (this.storeInfo.newFlag === 'Y') {
                if (this.controls.length === 0) {
                  this.$message.error('新设备门店，淋浴设备不可为空');
                }
                let sign = 0
                this.controls.forEach(item => {
                  if (item.lyId == null) {
                    sign = 1
                  }
                  if (item.port == null) {
                    sign = 2
                  }
                })
                if (sign === 1) {
                  this.$message.error('新设备门店，淋浴设备淋浴控制器不可为空');
                  return
                } else if (sign === 2) {
                  this.$message.error('新设备门店，淋浴设备端口不可为空');
                  return
                }
                params.controls = this.controls
                params.owners = "新设备无topic"
              } else {
                params.owners= params.owners.map(owner => owner.topic).join(',');
              }
              params.newFlag = this.storeInfo.newFlag

                const { data:res } = await this.$http.post('bathadd/',params)
                if(res.status===0)
                {
                    this.$message.success('添加成功！')
                    this.addDialogVisible = false
                    this.addForm.owners = [{
                        topic: '',
                        key: Date.now()
                    }]
                    this.getList()
                }else{
                    // 如果是门店重复设置的错误，显示详细信息
                    if(res.existingStoreName) {
                        this.$message({
                            message: res.message,
                            type: 'warning',
                            duration: 5000,
                            showClose: true
                        })
                    } else {
                        this.$message({message: res.message,type: 'error'})
                    }
                }
              this.btnLoading = false
            })
       },
       async EditInfo(id){
         this.getStoreList()
         const { data: res } = await this.$http.get('bathinfo/' + id)
         this.editForm = res.data
         this.storeInfo = {}
         this.controls =[]
         this.lyDevices = []
         this.editFormRules.deviceTopic = [
           { required: true, message: '请填写设备Topic', trigger: 'blur' }
         ]
         if (this.editForm.newFlag === 'Y') {
           this.editFormRules.deviceTopic = [
             { required: true, message: '请填写设备Topic', trigger: 'blur' }
           ]
           this.addForm.owners = [{
             topic: this.addForm.deviceTopic ? this.addForm.deviceTopic + "_1" : "",
             key: Date.now()
           }]
           const { data: res} = await this.$http.get('getLy/' + this.editForm.storeid)
           if (res.status === 0) {
             this.lyDevices = res.data
           }
           this.storeInfo = {
             id: id,
             newFlag: 'Y'
           }
           this.editFormRules.deviceTopic = []
           this.controls = this.editForm.controls
           this.editForm.topics = []
         } else {
           this.editForm.topics = res.data.topics.split(',').map((topic, index) => ({topic, key: index}))
         }
          this.editForm.admin_token =window.sessionStorage.getItem('admin_token')
          this.editDialogVisible = true
       },
        EditInfoSave(){
            this.$refs.editFormRef.validate(async valid => {
                if (!valid) return
              this.btnLoading = true
              let params = {...this.editForm}
              if (this.storeInfo.newFlag === 'Y') {
                if (this.controls.length === 0) {
                  this.$message.error('新设备门店，淋浴设备不可为空');
                }
                let sign = 0
                this.controls.forEach(item => {
                  if (item.lyId == null) {
                    sign = 1
                  }
                  if (item.port == null) {
                    sign = 2
                  }
                })
                if (sign === 1) {
                  this.$message.error('新设备门店，淋浴设备淋浴控制器不可为空');
                  return
                } else if (sign === 2) {
                  this.$message.error('新设备门店，淋浴设备端口不可为空');
                  return
                }
                params.controls = this.controls
                params.topics = "新设备无topic"
              } else {
                params.topics= params.topics.map(owner => owner.topic).join(',');
              }
              params.newFlag = this.storeInfo.newFlag

              const { data: res } = await this.$http.post('bathedit/' + params.id,params)
              if (res.status === 0) {
                  this.$message.success('信息修改成功')
                  this.editDialogVisible = false
                  this.getList()
              }
              this.btnLoading = false
            })
        },
        async DelInfo(id){
            const confirmResult = await this.$confirm('是否要删除此信息吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).catch(err => err)

                if (confirmResult !== 'confirm'){
                    return this.$message.info('已取消删除！')
                }
                const { data: res } = await this.$http.get('bathdel/'+ id,{ params:{admin_token:this.addForm.admin_token} })
            
                if (res.status === 0) { 
                    this.$message({message: '删除成功！',type: 'success'})
                }
                this.getList()
        },
        handleBlur(){
          this.addForm.owners.forEach((owner,cou) => {
            owner.topic = this.addForm.deviceTopic + "_" + (cou + 1)
          })
        },
      handleBlurEdit(){
        this.editForm.topics.forEach((owner,cou) => {
          owner.topic = this.editForm.deviceTopic + "_" + (cou + 1)
        })
      },
      // 点击查看图片
      handleLookPic(pic) {
        window.open(this.prefix + pic,'_blank');
      },
      async createQrcode(row) {
        const { data: res } = await this.$http.post('bathCreateCode/'+ row.id,{admin_token:window.sessionStorage.getItem('admin_token'), topics: row.topics,
          deviceTopic: row.deviceTopic, newFlag: row.newFlag, controls: row.qrcodes})

        if (res.status === 0) {
          this.$message({message: '生成成功！',type: 'success'})
          this.getList()
        }else {
          this.$message({message: res.message,type: 'error'})
        }
      },
      downloadQrcode(row) {
        const loading = this.$loading({
          lock: true,
          text: '下载中，请耐心等待',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        this.downloadImgZip(loading, row.qrcodes, row.storename)
      },
      // 处理下拉菜单命令
      handleCommand(command, row) {
        switch(command) {
          case 'edit':
            this.EditInfo(row.id);
            break;
          case 'delete':
            this.DelInfo(row.id);
            break;
          case 'createQrcode':
            this.createQrcode(row);
            break;
          case 'downloadQrcode':
            this.downloadQrcode(row);
            break;
        }
      },
      async downloadImgZip(loading, qrcodes, storename) {
        //图片下载-zip
        const zip = new JSZip();
        const imgFolder = zip.folder('images'); // 创建一个文件夹存放图片
        try {
          await Promise.all(qrcodes.map(async (row) => {
            if (row.qrcode) {
              const response = await fetch(this.prefix + row.qrcode +`?random=${Math.random().toString()}`);
              if (!response.ok) throw new Error(`Failed`);
              const blob = await response.blob();
              let imgType = blob.type.split('/')[1]
              imgFolder.file(`${row.name}.${imgType}`, blob); // 将图片添加到ZIP
            }
          }));
          const content = await zip.generateAsync({ type: 'blob' });
          FileSaver.saveAs(content, `${storename}淋浴码.zip`);
          loading.close()
        } catch (error) {
          //自己在这里处理错误
          console.error(error)
          loading.close()
        }
      },
      async handleStoreChange(val) {
        this.addFormRules.deviceTopic = [
          { required: true, message: '请填写设备Topic', trigger: 'blur' }
        ]
        this.editFormRules.deviceTopic = [
          { required: true, message: '请填写设备Topic', trigger: 'blur' }
        ]
        this.addForm.owners = [{
          topic: this.addForm.deviceTopic ? this.addForm.deviceTopic + "_1" : "",
          key: Date.now()
        }]
        this.storeInfo = {}
        this.lyDevices = []
        this.controls = []
        if (val) {
          this.storeInfo = this.storeMap.get(val);
          if (this.storeInfo.newFlag === 'Y') {
            this.addFormRules.deviceTopic = []
            this.editFormRules.deviceTopic = []
            this.addForm.owners = [{
              topic: "1",
              key: Date.now()
            }]
            const { data: res} = await this.$http.get('getLy/' + val)
            if (res.status === 0) {
              this.lyDevices = res.data
            }
          }
        }
      },
      handleDeleteRelay(index) {
        this.controls.splice(index, 1)
      },
      handleManagerChange(index) {
        let obj = this.controls[index]
        obj.port = null
        this.$set(this.controls, index, obj)
      }
    }
}
</script>
<style scoped>
    .button-group {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        max-width: 350px;
    }
    .button-group .el-button {
        margin-left: 0;
        margin-right: 5px;
        padding: 7px 10px;
    }
    .button-group .el-button:last-child {
        margin-right: 0;
    }
    /* 编辑和删除按钮保持小尺寸 */
    .button-group .el-button.is-circle {
        padding: 7px;
    }
    .cardcss{
        margin: 5px auto ;
        width: 100%;
    }
    .el-breadcrumb{
        width: 100%;
    }
    el-table__row>td {
    border: none;
    }

    .el-table::before {
    height: 0px;
    
    }
</style>